/* eslint-disable max-len */
import React from "react";

import styles from "./Footer.module.scss";

interface FooterColumnProps {
    title?: string;
}

const FooterColumn = (props: FooterColumnProps & React.HTMLProps<HTMLDivElement>) => {
    const {
        children, title, ...restProps
    } = props;

    return (
        <div {...restProps}>
            {title && <p className={styles.title}>{title}</p>}
            <ul className={styles.items}>{children}</ul>
        </div>
    );
};

export { FooterColumn as default };
